// removed by extract-text-webpack-plugin
module.exports = {"form-element":"account-name-and-email-settings__form-element___3v6i-","email":"account-name-and-email-settings__email___3kXSi"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/settings/account-name-and-email-settings.scss
// module id = 1352
// module chunks = 0